<template>
  <div flex="dir:left cross:center" :style="style">
    <div class="pft-compare-label">时间1：</div>
    <el-date-picker
      :disabled-date="disabledDateFun"
      @visible-change="panelChange"
      @calendar-change="calendarChange"
      @change="rangeChange"
      v-model="chooseDays"
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      popper-class="std-date-picker-popper"
      :format="chooseFormat"
      :shortcuts="shortcuts"
      :clearable="false"
      :holidays="holidays"
      style="margin-left: 11px"
      ref="date1Picker"
    ></el-date-picker>

    <div class="pft-compare-text">对比</div>
    <div class="pft-compare-label">时间2：</div>
    <el-date-picker
      ref="date2Picker"
      :disabled-date="disabledDateFun"
      @calendar-change="calendarChange"
      @visible-change="panelChange"
      @change="compareRangeChange"
      @clear="clearCompareRangeChange"
      v-model="compareChooseDays"
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      popper-class="std-date-picker-popper"
      :holidays="holidays"
      :format="chooseFormat"
      :shortcuts="shortcuts"
      style="margin-left: 11px"
    ></el-date-picker>
    <el-button style="margin-left: 11px" type="primary" @click="check">查询</el-button>
  </div>
</template>
<script lang="ts" setup>
import { ref, provide } from "vue"
import { useDark, useToggle } from "@vueuse/core"
import { ElButton } from "element-plus"
//使用elemet-plus的DatePicker组件进行改写，使其支持传入节假日数据，并且支持在日历中切换到节假日快速选择
import ElDatePicker from "@p-v/libs/element-customer-ui/components/date-picker"

import { onMounted, computed } from "vue"
import moment from "moment"

// 节假日数据接口
interface HolidayData {
  [year: string]: { start: string; end: string; name: string }[]
}

const props = withDefaults(
  defineProps<{
    style?: { [key: string]: string }
    minDate?: string
    start?: string
    end?: string
    compareStart?: string
    compareEnd?: string
    dayRange?: number
    t?: undefined | "0" | "1"
    holidaysUrl?: string // 新增: 获取节假日数据的URL
  }>(),
  {
    style: () => ({}),
    minDate: () => "2022-01-01",
    start: () => "2022-01-01",
    end: () => "2022-01-01",
    compareStart: undefined,
    compareEnd: undefined,
    dayRange: () => 93,
    holidaysUrl: undefined, // 默认为undefined
  },
)

// 添加一个ref存储节假日数据
const holidays = ref<HolidayData>({})

const emits = defineEmits<{
  (e: "update:start", start: string): void
  (e: "update:end", end: string): void
  (e: "update:compareStart", compareStart: string | undefined): void
  (e: "update:compareEnd", compareEnd: string | undefined): void
}>()

const dateModel = ref("sevenDays")
const rangeFirst = ref("")

const date1Picker = ref<InstanceType<typeof ElDatePicker> | null>(null)
const date2Picker = ref<InstanceType<typeof ElDatePicker> | null>(null)

const minDate = moment(props.minDate)
const maxDate = moment().endOf("day")
if (props.t === "1") {
  maxDate.subtract(1, "days")
}
const chooseDays = ref<string[]>([props.start, props.end])
const compareChooseDays = ref<string[]>([props.compareStart!, props.compareEnd!])
const chooseFormat = ref("YYYY-MM-DD")
const shortcuts = computed(() => {
  const yeasterday = moment().endOf("day").subtract(1, "days")
  const weekStart = moment().startOf("week")
  const monthStart = moment().startOf("month")
  const range = [
    // 昨天
    {
      text: "昨天",
      value: () => {
        const startTime = moment().startOf("day").subtract(1, "days").toDate()
        const endTime = moment().endOf("day").subtract(1, "days").toDate()
        return [startTime, endTime]
      },
    },
  ]
  if (weekStart.isBefore(yeasterday)) {
    range.push({
      text: "本周",
      value: () => {
        const startTime = moment().startOf("week").toDate()
        let endTime = moment().endOf("week").toDate()
        if (props.t === "1") {
          endTime = moment().subtract(1, "days").endOf("day").toDate()
        } else if (props.t === "0") {
          endTime = moment().endOf("day").toDate()
        }
        return [startTime, endTime]
      },
    })
  }
  range.push({
    text: "上周",
    value: () => {
      const startTime = moment().startOf("week").subtract(1, "weeks").toDate()
      const endTime = moment().endOf("week").subtract(1, "weeks").toDate()
      return [startTime, endTime]
    },
  })
  if (monthStart.isBefore(yeasterday)) {
    range.push({
      text: "本月",
      value: () => {
        const startTime = moment().startOf("month").toDate()
        let endTime = moment().endOf("month").toDate()
        if (props.t === "1") {
          endTime = moment().subtract(1, "days").endOf("day").toDate()
        } else if (props.t === "0") {
          endTime = moment().endOf("day").toDate()
        }
        return [startTime, endTime]
      },
    })
  }
  range.push({
    text: "上月",
    value: () => {
      const startTime = moment().startOf("month").subtract(1, "months").toDate()
      const endTime = moment().endOf("month").subtract(1, "months").toDate()
      return [startTime, endTime]
    },
  })

  return range
})
const disabledDateFun = (date: any) => {
  let disMinDate = minDate
  let disMaxDate = maxDate
  if (rangeFirst.value) {
    const last93 = moment(rangeFirst.value).add(props.dayRange, "days")
    const past93 = moment(rangeFirst.value).subtract(props.dayRange, "days")
    if (disMaxDate.isAfter(last93)) {
      disMaxDate = last93
    }
    if (disMinDate.isBefore(past93)) {
      disMinDate = past93
    }
  }
  return !moment(date).isBetween(disMinDate, disMaxDate)
}
const panelChange = (isOpen: boolean) => {
  rangeFirst.value = ""
}
const calendarChange = (dates: string) => {
  const [first] = dates
  rangeFirst.value = first
  dateModel.value = ""
}
const rangeChange = (dates: string) => {
  if (dates === null) {
    rangeFirst.value = ""
    chooseDays.value = []
    return
  }
  const [first, second] = dates
  // rangeFirst.value = first;
  chooseDays.value = [moment(first).format(chooseFormat.value), moment(second).format(chooseFormat.value)]
}

const compareRangeChange = (dates: string) => {
  if (dates === null) {
    rangeFirst.value = ""
    chooseDays.value = []
    return
  }
  const [first, second] = dates
  // rangeFirst.value = first;
  compareChooseDays.value = [moment(first).format(chooseFormat.value), moment(second).format(chooseFormat.value)]
}
const clearCompareRangeChange = () => {
  chooseDays.value = [props.start, props.end]
}
const check = () => {
  emits("update:start", moment(chooseDays.value[0]).format(chooseFormat.value))
  emits("update:end", moment(chooseDays.value[1]).format(chooseFormat.value))
  if (compareChooseDays.value) {
    console.log("compareChooseDays", compareChooseDays.value)
    emits("update:compareStart", compareChooseDays.value[0] ? moment(compareChooseDays.value[0]).format(chooseFormat.value) : undefined)
    emits("update:compareEnd", compareChooseDays.value[1] ? moment(compareChooseDays.value[1]).format(chooseFormat.value) : undefined)
  } else {
    emits("update:compareStart", undefined)
    emits("update:compareEnd", undefined)
  }
}

// 获取节假日数据的函数
const fetchHolidays = async () => {
  if (!props.holidaysUrl) return

  try {
    const response = await fetch(props.holidaysUrl)
    if (!response.ok) {
      console.error("Failed to fetch holidays data:", response.statusText)
      return
    }

    const data = await response.json()
    holidays.value = data
    console.log("Holidays data loaded successfully")
  } catch (error) {
    console.error("Error fetching holidays data:", error)
  }
}

// 在组件挂载时获取节假日数据
onMounted(() => {
  const isDark = useDark()
  isDark.value = true
  useToggle(isDark)

  // 获取节假日数据
  if (props.holidaysUrl) {
    fetchHolidays()
  }
})

// 检查日期是否是节假日的辅助函数
const isHoliday = (date: string): { isHoliday: boolean; name?: string } => {
  const year = date.substring(0, 4)
  const yearData = holidays.value[year]

  if (!yearData) return { isHoliday: false }

  // 检查节假日
  const holiday = yearData.find(h => {
    const start = moment(h.start)
    const end = moment(h.end)
    return moment(date).isBetween(start, end, undefined, "[]")
  })
  if (holiday) return { isHoliday: true, name: holiday.name }

  return { isHoliday: false }
}

// 这个函数可以用于在日历中标记节假日，可以后续扩展功能
defineExpose({
  isHoliday,
  holidays,
})
</script>
<style lang="scss">
.pft-compare-label {
  font-size: 14px;
  font-weight: 400;
  color: #b5b5b5;
  margin-right: 8px;
  text-align: right;
  min-width: 60px;
  flex-shrink: 0;
}
.pft-compare-text {
  font-size: 14px;
  font-weight: 400;
  color: #b5b5b5;
  min-width: 50px;
  margin: 0 8px 0 16px;
  text-align: center;
  flex-shrink: 0;
}
</style>
